import React, { useEffect, useState } from "react";
import api from "../../api";
import { toast } from "sonner";
import { KeyRound, Save, Eye, EyeOff, CheckCircle2 } from "lucide-react";

const inputCls = "flex-1 min-w-[200px] border border-gray-300 rounded-sm px-3 py-2 text-[14px] outline-none focus:border-[#16345c] bg-white";

export const AnteprimaPasswordPanel = () => {
  const [info, setInfo] = useState({ configured: false });
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [saving, setSaving] = useState(false);

  const load = () => {
    api.get("/anteprima/settings")
      .then((r) => setInfo(r.data || {}))
      .catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const save = () => {
    if (password.trim().length < 4) { toast.error("La password deve avere almeno 4 caratteri"); return; }
    setSaving(true);
    api.put("/anteprima/settings", { password: password.trim() })
      .then((r) => {
        setInfo(r.data || {});
        setPassword("");
        toast.success("Password dell'anteprima aggiornata");
      })
      .catch((e) => toast.error(e?.response?.data?.detail || "Errore durante il salvataggio"))
      .finally(() => setSaving(false));
  };

  const fmt = (iso) => { try { return new Date(iso).toLocaleString("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); } catch { return iso; } };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mb-5" data-testid="anteprima-password-panel">
      <div className="flex items-center gap-2 mb-1">
        <span className="w-9 h-9 rounded-lg bg-[#ff7e00]/12 text-[#ff7e00] flex items-center justify-center"><KeyRound size={18} /></span>
        <div>
          <h3 className="text-[15px] font-black text-[#16345c] leading-tight">Password pagina anteprima</h3>
          <p className="text-[12px] text-gray-500">Password condivisa richiesta per accedere alla pagina <span className="font-mono">/anteprima</span>.</p>
        </div>
      </div>

      <p className="text-[12.5px] text-gray-600 bg-[#f0f2f5] rounded-sm px-3 py-2 my-3 flex items-center gap-2">
        {info.configured
          ? <><CheckCircle2 size={15} className="text-green-600" /> Password impostata{info.updated_at ? ` · ultima modifica ${fmt(info.updated_at)}${info.updated_by ? ` · ${info.updated_by}` : ""}` : ""}</>
          : "Nessuna password impostata: la pagina anteprima non è protetta."}
      </p>

      <div className="flex flex-wrap items-center gap-3">
        <div className="relative flex-1 min-w-[200px]">
          <input
            type={show ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Nuova password anteprima"
            data-testid="anteprima-password-input"
            className={`${inputCls} w-full pr-10`}
          />
          <button type="button" onClick={() => setShow((s) => !s)} data-testid="anteprima-password-toggle" className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
            {show ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>
        <button onClick={save} disabled={saving} data-testid="anteprima-password-save" className="flex items-center gap-2 bg-[#16345c] hover:bg-[#0d1b2f] text-white text-[13px] font-bold px-4 py-2 rounded-sm transition-colors disabled:opacity-60">
          <Save size={15} /> {saving ? "Salvataggio…" : "Salva password"}
        </button>
      </div>
      <p className="text-[11px] text-gray-400 mt-2">Chi ha già effettuato lo sblocco resta dentro fino alla scadenza del proprio accesso (3 giorni); la nuova password vale per i prossimi accessi.</p>
    </div>
  );
};
